import React from 'react';
import { ListColumnType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import WorkerPairForm from './WorkerPairForm';

// Rename the name of the function:
const WorkerPairList: React.FC = () => {

    // Specify the options of this list:
    const query = {
        endpoint: 'get_workerpair_list',
        defaultParams: {
            'deleted': false,
        },
        object: 'workerpair'
    }
    const objectName = 'scheduling.worker_pairs.object_name'
    const showSearch = false
    const showDeleteOrDeactivate = 'flag_deleted'

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = false

    // Specify form, detail modal or detailpage for this list
    const formModal = <WorkerPairForm />;
    const modalSize = 'medium'
    const onRowClick = 'editModal'

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '1fr', field: 'foreman', label: 'scheduling.worker_pairs.foreman_label', render: (value) => <>{value?.full_name}</> },
        { width: '1fr', field: 'helper', label: 'scheduling.worker_pairs.helper_label', render: (value) => <>{value?.full_name}</> },
    ];

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            columns={columns}
            showSearch={showSearch}
            showDeleteOrDeactivate={showDeleteOrDeactivate}
            formModal={formModal}
            modalSize={modalSize}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
        />
    );
};

export default WorkerPairList;
